import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import WidgetComponent from "../../components/Widget";
import FireAssuranceContext from "./FireAssuranceContext";
import CheckBoxInsurance from "../../components/CheckBoxInsurance";
import { Accordion } from "react-bootstrap";
import DataService from "../../service/data";
import CoverDetails from "../../components/CoverDetailsModal";
import { TYPE_CODES } from "../../const";

class FireAssuranceStep1 extends Component {
  state = {
    selected: "",
    coverDetails: []
  };
  constructor(props) {
    super(props);
  }

  _onChangePlan = selected => {
    this.setState({ ...this.state, selected });
  };

  async initCoverDetail(productCode, selectedPackage, custOrder) {
    try {
      const responses = await DataService.getCoverDetails({
        product_code: productCode,
        package_code: selectedPackage,
        cust_order: custOrder
      });

      this.setState({
        ...this.state,
        coverDetails: responses
      });
    } catch (err) {
      console.log(err);
    }
  }

  showModal = () => {
    const { coverDetails } = this.state;

    this.setState({ show: true }, () => {
      if (coverDetails.length === 0) {
        setTimeout(() => {
          this.initCoverDetail(TYPE_CODES.FA, "FR001", "1");
        }, 1000);
      }
    });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      selectedPlan,
      planList,
      acceptInsurance,
      onChangeModel,
      defaultKey = 'FR001'
    } = this.context.step1;
    const { show, coverDetails } = this.state;

    return (
      <div className="form-wrapper">
        <Accordion
          className="accordion-widget-wrapper"
          defaultActiveKey={defaultKey}
        >
          {planList.map((item, index) => {
            return (
              <WidgetComponent
                key={index}
                defaultToggle={true}
                listItem={item}
                selected={selectedPlan}
                  showModal={this.showModal}
                onChangePlan={selected =>
                  onChangeModel({ name: "selectedPlan", value: selected })
                }
              />
            );
          })}
          <CoverDetails
            show={show}
            hideModal={this.hideModal}
            listItem={planList} //item
            insurance_type={"ประกันอุบัติเหตุ"}
            productCode={TYPE_CODES.FA}
            selectedPackage={"FR001"}
            custOrder={"1"}
            coverDetails={coverDetails}
          />
        </Accordion>
        <p className="text-helper">
          * ประกันภัยฉบับนี้คุ้มครองเฉพาะสิ่งปลูกสร้าง (บ้านเดี่ยว)
          ในกรณีที่สิ่งปลูกสร้างเป็นคอนกรีตเท่านั้น
        </p>
        <div className="form-wrapper pl-0">
          <CheckBoxInsurance
            checked={acceptInsurance}
            onCheckChange={checked =>
              onChangeModel({ name: "acceptInsurance", value: checked })
            }
          />
        </div>
      </div>
    );
  }
}
FireAssuranceStep1.contextType = FireAssuranceContext;
export default withRouter(FireAssuranceStep1);
